import { MINUTES_TO_MS, SECONDS_TO_MS } from '@utils/constants';

function formatTime(timeInMs) {
  if (typeof timeInMs !== "number") {
    return "";
  }
  const minutes = Math.floor(timeInMs / MINUTES_TO_MS);
  const seconds = Math.round(timeInMs / SECONDS_TO_MS) % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export { formatTime };
//# sourceMappingURL=util.format-time.js.map
